import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { SupplementHashAnchorsModule } from '@spartacus/storefront';
import { CustomParagraphComponent } from './paragraph.component';

@NgModule({
  imports: [CommonModule, RouterModule, SupplementHashAnchorsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSParagraphComponent: {
          component: CustomParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: CustomParagraphComponent,
        },
      },
    }),
  ],
  declarations: [CustomParagraphComponent],
  exports: [CustomParagraphComponent],
})
export class CustomCmsParagraphModule {}
